var map = {
	"./android/detection": 921,
	"./androidtv/detection": 922,
	"./arris/detection": 923,
	"./hisense/detection": 924,
	"./lg/detection": 925,
	"./nagra/detection": 926,
	"./netrange/detection": 927,
	"./opera/detection": 928,
	"./polaroid/detection": 929,
	"./ps4/detection": 930,
	"./samsung/detection": 931,
	"./seirobotics/detection": 932,
	"./sony/detection": 933,
	"./stbcoship/detection": 934,
	"./stbcoship9108/detection": 935,
	"./stbhuawei/detection": 936,
	"./stbkaon/detection": 937,
	"./tizen/detection": 938,
	"./web0s/detection": 939,
	"./workstation/detection": 940,
	"./workstationChafari/detection": 941,
	"./zeasn/detection": 942,
	"./zte/detection": 943
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 920;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/detection$
// module id = 920
// module chunks = 0